// This will get imported in main.js
export const logSomething = msg => {
    console.log(msg);
};